import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "connector-icon mr-s2" }
const _hoisted_3 = ["src"]

import Icon from '@/components/icon/Icon.vue';
import { computed, ref } from 'vue';
import connectors from '@/helpers/connectors/wallets/connectors.json';
import { useCardanoWallet } from '@/store/modules/wallet/useCardanoWallet';
import { IWalletsList } from '@/store/modules/wallet/models/wallets-list.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectWalletButton',
  props: {
    label: null,
    buttonIcon: { type: Boolean },
    isError: { type: Boolean },
    connectors: null,
    btnClass: null
  },
  emits: ["onSelectWallet"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onSelectWallet', id: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  label?: string;
  buttonIcon?: boolean;
  isError?: boolean;
  connectors: string;
  btnClass?: string;
}




const cardanoWallet = useCardanoWallet();
const walletPanel = ref();
const walletList = computed(() => {
  let wallets: IWalletsList[] = [];
  if (props.connectors === 'default') {
    Object.keys(connectors).forEach(item => {
      wallets.push(connectors[item]);
    });
  } else {
    wallets = cardanoWallet.getAvailableConnectorsList;
  }
  return wallets;
});
const toggleWalletPanel = event => {
  walletPanel.value.toggle(event);
};
const onSelect = id => {
  walletPanel.value.hide();
  emits('onSelectWallet', id);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, _mergeProps({
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleWalletPanel($event)))
    }, _ctx.$attrs, {
      "aria-controls": "overlay_panel",
      class: __props.btnClass
    }), {
      default: _withCtx(() => [
        (__props.buttonIcon)
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              name: __props.isError ? 'danger' : 'wallet',
              size: "20",
              class: _normalizeClass(["mr-s1", { 'text-gray': !__props.isError }])
            }, null, 8, ["name", "class"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(__props.label || _ctx.$t('wallet.connect')), 1)
      ]),
      _: 1
    }, 16, ["class"]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "walletPanel",
      ref: walletPanel,
      class: "dropdown-list",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletList), (connector, id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: id,
            class: "dropdown-li",
            onClick: ($event: any) => (onSelect(connector.id))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: connector.icon
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", null, _toDisplayString(connector.name), 1)
          ], 8, _hoisted_1))
        }), 128))
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})